/*
* Copyright (C) Regione Lombardia
*/
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AnagraficaClasseDocumentoPipe } from './anagrafica/classe-documento.pipe';
import { AnagraficaComuniPipe } from './anagrafica/comuni.pipe';
import { AnagraficaEntePipe } from './anagrafica/ente.pipe';
import { AnagraficaEventoPipe } from './anagrafica/evento.pipe';
import { AnagraficaFascePercentualiPipe } from './anagrafica/fasce-percentuali.pipe';
import { AnagraficaFontePipe } from './anagrafica/fonte.pipe';
import { AnagraficaFunzionePrevalentePipe } from './anagrafica/funzione-prevalente.pipe';
import { AnagraficaImportanzaOperaPipe } from './anagrafica/importanza-opera.pipe';
import { AnagraficaLeggePipe } from './anagrafica/legge.pipe';
import { AnagraficaLivelloDannoPipe } from './anagrafica/livello-danno.pipe';
import { AnagraficaMacroTipologiaOperaPipe } from './anagrafica/macro-tipologia-opera.pipe';
import { AnagraficaMaterialePipe } from './anagrafica/materiale.pipe';
import { AnagraficaProvenienzaPipe } from './anagrafica/provenienza.pipe';
import { AnagraficaProvincePipe } from './anagrafica/province.pipe';
import { AnagraficaRuoloPipe } from './anagrafica/ruolo.pipe';
import { AnagraficaSpondaPipe } from './anagrafica/sponda.pipe';
import { AnagraficaStatoOperaPipe } from './anagrafica/stato-opera.pipe';
import { AnagraficaStatoProgettoPipe } from './anagrafica/stato-progetto.pipe';
import { AnagraficaTipologiaInterventoPipe } from './anagrafica/tipologia-intervento.pipe';
import { AnagraficaTipologiaOperaPipe } from './anagrafica/tipologia-opera.pipe';
import { AnagraficaTipologiaRilevamentoPipe } from './anagrafica/tipologia-rilevamento.pipe';
import { AnagraficaUtenteStatusPipe } from './anagrafica/utente-status.pipe';
import { ReactiveFormShowErrorsMessagePipe } from './reactive-form/show-errors-message.pipe';
import { UtilitiesConvertFileSizePipe } from './utilities/convert-file-size.pipe';
import { UtilitiesSpecialCharactersPipe } from './utilities/special-characters.pipe';
import { AnagraficaClassificazioneOperaPipe } from './anagrafica/classificazione-opera.pipe';

@NgModule({
    imports: [
        CommonModule,
    ],
    declarations: [
        AnagraficaClasseDocumentoPipe,
        AnagraficaClassificazioneOperaPipe,
        AnagraficaComuniPipe,
        AnagraficaEntePipe,
        AnagraficaEventoPipe,
        AnagraficaFascePercentualiPipe,
        AnagraficaFontePipe,
        AnagraficaFunzionePrevalentePipe,
        AnagraficaImportanzaOperaPipe,
        AnagraficaLeggePipe,
        AnagraficaLivelloDannoPipe,
        AnagraficaMacroTipologiaOperaPipe,
        AnagraficaMaterialePipe,
        AnagraficaProvenienzaPipe,
        AnagraficaProvincePipe,
        AnagraficaRuoloPipe,
        AnagraficaSpondaPipe,
        AnagraficaStatoOperaPipe,
        AnagraficaStatoProgettoPipe,
        AnagraficaTipologiaInterventoPipe,
        AnagraficaTipologiaOperaPipe,
        AnagraficaTipologiaRilevamentoPipe,
        AnagraficaUtenteStatusPipe,
        ReactiveFormShowErrorsMessagePipe,
        UtilitiesConvertFileSizePipe,
        UtilitiesSpecialCharactersPipe,
    ],
    exports: [
        AnagraficaClasseDocumentoPipe,
        AnagraficaClassificazioneOperaPipe,
        AnagraficaComuniPipe,
        AnagraficaEntePipe,
        AnagraficaEventoPipe,
        AnagraficaFascePercentualiPipe,
        AnagraficaFontePipe,
        AnagraficaFunzionePrevalentePipe,
        AnagraficaImportanzaOperaPipe,
        AnagraficaLeggePipe,
        AnagraficaLivelloDannoPipe,
        AnagraficaMacroTipologiaOperaPipe,
        AnagraficaMaterialePipe,
        AnagraficaProvenienzaPipe,
        AnagraficaProvincePipe,
        AnagraficaRuoloPipe,
        AnagraficaSpondaPipe,
        AnagraficaStatoOperaPipe,
        AnagraficaStatoProgettoPipe,
        AnagraficaTipologiaInterventoPipe,
        AnagraficaTipologiaOperaPipe,
        AnagraficaTipologiaRilevamentoPipe,
        AnagraficaUtenteStatusPipe,
        ReactiveFormShowErrorsMessagePipe,
        UtilitiesConvertFileSizePipe,
        UtilitiesSpecialCharactersPipe,
    ],
})
export class SharedPipeModule { }
